<div class="main">
  <spb-header></spb-header>
  <router-outlet></router-outlet>
  <div [style.flex]="1"></div>
  <spb-footer
    (logoutUser)="configService.reset()"
    [license]="true"
    [token]="configService.accessToken()"
    [version]="version"
    copyrightYears="2025"
  ></spb-footer>
</div>